<template>
  <footer class="footer has-cards">

    <div class="container">
      <div class="row row-grid align-items-center my-md">

        <div class="col-lg-6 text-lg-center btn-wrapper">
          <a
            target="_blank"
            href="https://twitter.com/jpop_jam"
            class="btn btn-neutral btn-icon-only btn-twitter btn-round btn-lg"
            data-toggle="tooltip"
            data-original-title="Follow us"
          >
            <i class="fa fa-twitter"></i>
          </a>
          <a
            target="_blank"
            href="https://www.facebook.com/jpopjam"
            class="btn btn-neutral btn-icon-only btn-facebook btn-round btn-lg"
            data-toggle="tooltip"
            data-original-title="Like us"
          >
                <i class="fa fa-facebook-square"></i>

          </a>
          <a
            target="_blank"
            href="https://www.instagram.com/jpopjam/"
            class="btn btn-neutral btn-icon-only btn-dribbble btn-lg btn-round"
            data-toggle="tooltip"
            data-original-title="Follow us"
          >
           <i class="fa fa-instagram"></i>
          </a>
        </div>
      </div>
      <hr>
      <div class="row align-items-center justify-content-md-between">
        <div class="col-md-6">
          <div class="copyright">
            &copy; 2019
            <a href="https://j-pop-jam.com" target="_blank">Made with <i class="fa fa-heart"></i> by J-POP JAM Team</a>
          </div>
        </div>

      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style>
</style>
